// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S2cAK","title":"styles_title__2miUg"};